import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import { IconButton } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';

const styles = (theme) => ({
  root: {
  },
  content: {
    width: '100%',
  },
  previousButton: {
    marginRight: theme.spacing(3),
  },
  iconStyle: {
    fill: theme.palette.facet.red,
  },
  title: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignContent: 'center',
    alignItems: 'center',
  },
  fields: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
  },
});

const ExpenseLayout = ({
  className,
  classes,
  index,
  onRemove,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Box p={1} className={classes.title}>
        <IconButton
          icon={DeleteOutlineIcon}
          color="red"
          className={classes.iconStyle}
          onClick={() => {
            onRemove(index);
          }}
        />
      </Box>
      <Box className={classes.fields}>
        <MetaControlField
          attr={'name'}
        />
        <MetaControlField
          attr={'value'}
        />
      </Box>
    </Box>
  );
};

ExpenseLayout.defaultProps = {
  className: '',
};

ExpenseLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  onRemove: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};

export default withStyles(styles)(ExpenseLayout);
